export const MLB_TEAMS_DICTIONARY = new Map([
    ["Toronto Blue Jays", "chk_Team_TOR"],
    ["Baltimore Orioles", "chk_Team_BAL"],
    ["Tampa Bay Rays", "chk_Team_TB"],
    ["Boston Red Sox", "chk_Team_BOS"],
    ["New York Yankees", "chk_Team_NYY"],
    ["Cleveland Guardians", "chk_Team_CLE"],
    ["Kansas City Royals", "chk_Team_KC"],
    ["Detroit Tigers", "chk_Team_DET"],
    ["Minnesota Twins", "chk_Team_MIN"],
    ["Chicago White Sox", "chk_Team_CWS"],
    ["Los Angeles Angels", "chk_Team_LAA"],
    ["Houston Astros", "chk_Team_HOU"],
    ["Oakland Athletics", "chk_Team_OAK"],
    ["Seattle Mariners", "chk_Team_SEA"],
    ["Texas Rangers", "chk_Team_TEX"],
    ["Atlanta Braves","chk_Team_ATL"],
    ["Miami Marlins","chk_Team_MIA"],
    ["New York Mets","chk_Team_NYM"],
    ["Washington Nationals","chk_Team_WAS"],
    ["Philadelphia Phillies", "chk_Team_PHI"],
    ["Milwakee Brewers", "chk_Team_MIL"],
    ["St. Louis Cardinals", "chk_Team_STL"],
    ["Chicago Cubs", "chk_Team_CHC"],
    ["Pittsburgh Pirates", "chk_Team_PIT"],
    ["Cincinnati Reds", "chk_Team_CIN"],
    ["Arizona Diamondbacks", "chk_Team_ARI"],
    ["Los Angeles Dodgers", "chk_Team_LAD"],
    ["San Francisco Giants", "chk_Team_SF"],
    ["San Diego Padres", "chk_Team_SD"],
    ["Colorado Rockies", "chk_Team_COL"],
]);

export const INNING_OPTIONS = [
    {key: 0, value: 1, text: "1"},
    {key: 1, value: 2, text: "2"},
    {key: 2, value: 3, text: "3"},
    {key: 3, value: 4, text: "4"},
    {key: 4, value: 5, text: "5"},
    {key: 5, value: 6, text: "6"},
    {key: 6, value: 7, text: "7"},
    {key: 7, value: 8, text: "8"},
    {key: 8, value: 9, text: "9"},
    {key: 9, value: 10, text: "Extra innings"},
];

export const PITCH_GLOSSARY = new Map([
    ["Called", "Called strike"],
    ["Ball", "Ball"],
    ["Hit", "Hit into play"],
    ["Foul", "Foul"],
    ["Swinging", "Swinging strike"],
]);